export enum EListCalendarViewModes {
  ListView,
  CalendarView
}